import { Box, Stack } from '@mui/material';
import HeaderSkeleton from './HeaderSkeleton';
import InfoCardSkeleton from './InfoCardSkeleton';

export default function UserDetailsSkeleton() {
    return (
        <Box>
            <Box
                sx={{
                    backgroundColor: 'neutral.white',
                    padding: '16px 24px',
                    borderBottom: '1px solid',
                    borderColor: 'neutral.borderColor',
                }}
            >
                <HeaderSkeleton />
            </Box>
            <Stack direction="row" m={3} spacing={3}>
                <InfoCardSkeleton numFields={5} />
                <InfoCardSkeleton numFields={3} />
            </Stack>
        </Box>
    );
}
